import Vue from "vue";
import { vm } from "@/main";
import config from '@/assets/js/config/Config'

import { formatVideoTime, stripTimestampAndExtension } from "@/assets/js/Utilities";
import $ from "jquery";

const getDefaultState = () => {
	return {
		UILoadedStatus: false,
		leftColumn: 'appliedBlocks',
		rightColumn: 'project',
		addBlockList: 'control',
		blockListSearchTerm: '',
		previewBasedBlock: false,
		// addBlockMenu: false,
		filteredBlockList: [],
		filmstrip: {
			active: false,
			height: 70,
		},
		scopes: false,
		startTipsStep: null,
		video: {
			isLoaded: false,
			playing: false,
			duration: null,
			currentTime: "0:00",
			loop: false,
			durationMs: null,
			currentTimeMs: null,
		},
		addingMatchAnimation: false,
		matches: [],
		matchSearchTerm: "",
		addingCandidateAnimation: false,
		candidates: [],
		candidateSearchTerm: "",
		AIColourExtract: {
			isDownloading: false,
			downloadProgress: null
		},
		AIAutoCorrect: {
			isDownloading: false,
			downloadProgress: null
		},
		neuralFilmAI: {
			isDownloading: false,
			downloadProgress: null
		},
		regenerateAIBasedPreviewsButton: false,
		AIMagicMode: {
			isDownloading: false,
			downloadProgress: null,
		},
		AIExposure: {
			isDownloading: false,
			downloadProgress: null,
		},
		AIContrast: {
			isDownloading: false,
			downloadProgress: null,
		},
		AIWhiteBalance: {
			isDownloading: false,
			downloadProgress: null,
		},
		showAddMatchTooltip: "",
		showRawDevelopment: false,
		rawDeveloped: false,
		backgroundColor: '#191919',
		compareView: [],
		neuralFilmAIProcessingStep: 1,
		neuralFilmAIProcessingModalTitle: '',
		showLutPreviews: true,
		splitView: false,
		addingPresetAnimation: false,
		gamutCompression: false,
		isWhatsNewDrawerOpen: false,
		whatsNewButtonAnimation: false,

	};
};

const UI = {
	namespaced: true,

	state: getDefaultState(),
	mutations: {
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
		RESET_VIDEO: state => {
			Object.assign(state.video, getDefaultState().video);
		},
		SET_UI_LOADED_STATUS: (state, payload) => {
			state.UILoadedStatus = payload;
		},
		SET_LEFT_COLUMN: (state, payload) => {
			state.leftColumn = payload;
		},
		SET_RIGHT_COLUMN: (state, payload) => {
			state.rightColumn = payload;
		},
		SET_ADD_BLOCK_LIST: (state, payload) => {
			state.addBlockList = payload;
		},
		SET_BLOCK_LIST_SEARCH_TERM: (state, payload) => {
			state.blockListSearchTerm = payload;
		},
		SET_FILTERED_BLOCK_LIST: (state, payload) => {
			state.filteredBlockList = payload;
		},
		SET_PREVIEW_BASED_BLOCKS: (state, payload) => {
			state.previewBasedBlock = payload;
		},
		SET_FILMSTRIP: (state, payload) => {
			state.filmstrip.active = payload;
		},
		SET_SCOPES: (state, payload) => {
			state.scopes = payload;
		},
		SET_START_TIPS_STEP: (state, payload) => {
			state.startTipsStep = payload;
		},
		SET_VIDEO_LOADED: (state, payload) => {
			state.video.isLoaded = payload;
		},
		SET_VIDEO_DURATION: (state, payload) => {
			state.video.duration = formatVideoTime(payload);
			state.video.durationMs = payload;
		},
		SET_CURRENT_TIME: (state, payload) => {
			state.video.currentTime = formatVideoTime(payload);
			state.video.currentTimeMs = payload;
		},
		SET_VIDEO_LOOP: state => {
			state.video.loop = !state.video.loop;
		},
		SET_VIDEO_PLAYING: state => {
			state.video.playing = !state.video.playing;
		},
		SET_ANIMATION_FOR_ADDING_MATCH: (state, payload) => {
			state.addingMatchAnimation = payload;
		},
		ADD_MATCH: (state, payload) => {
			state.matches.push(payload)
		},
		REMOVE_MATCHES: state => {
			state.matches = [];
		},
		REMOVE_MATCH: (state, payload) => {
			state.matches = state.matches.filter(match => match.id !== payload);
		},
		RENAME_MATCH: (state, payload) => {
			state.matches.forEach(match => {
				if (match.id == payload.id) {
					match.name = payload.name;
					match.nicename = payload.nicename;
				}
			})
		},
		SET_ANIMATION_FOR_ADDING_CANDIDATE: (state, payload) => {
			state.addingCandidateAnimation = payload;
		},
		ADD_CANDIDATE: (state, payload) => {
			state.candidates.push(payload);
		},
		REMOVE_CANDIDATES: state => {
			state.candidates = [];
		},
		REMOVE_CANDIDATE: (state, payload) => {
			state.candidates = state.candidates.filter(candidate => candidate.id !== payload);
		},
		RENAME_CANDIDATE: (state, payload) => {
			if (state.candidates.find(candidate => candidate.id == payload.id)) {
				state.candidates.find(candidate => candidate.id == payload.id).name = payload.name;
				state.candidates.find(candidate => candidate.id == payload.id).nicename = payload.nicename;
			}
		},
		UPDATE_CANDIDATE_TAGS: (state, payload) => {
			state.candidates.forEach(candidate => {
				if (candidate.id !== payload.id) return;

				candidate.tags = payload.tags;
			})
		},
		UPDATE_MATCH_TAGS: (state, payload) => {
			state.matches.forEach(match => {
				if (match.id !== payload.id) return;

				match.tags = payload.tags;
			})
		},
		UPDATE_CANDIDATE_THUMBNAIL: (state, payload) => {
			state.candidates.find(candidate => candidate.id == payload.id).thumbnailBlob = payload.thumbnailBlob;
		},
		SET_AI_COLOUR_EXTRACT_DOWNLOAD_PROGRESS: (state, payload) => {
			state.AIColourExtract.downloadProgress = payload;
		},
		SET_AI_COLOUR_EXTRACT_DOWNLOADING: (state, payload) => {
			state.AIColourExtract.isDownloading = payload;
		},
		SET_AI_AUTO_CORRECT_DOWNLOAD_PROGRESS: (state, payload) => {
			state.AIAutoCorrect.downloadProgress = payload;
		},
		SET_AI_AUTO_CORRECT_DOWNLOADING: (state, payload) => {
			state.AIAutoCorrect.isDownloading = payload;
		},
		SET_NEURAL_FILM_AI_DOWNLOAD_PROGRESS: (state, payload) => {
			state.neuralFilmAI.downloadProgress = payload;
		},
		SET_NEURAL_FILM_AI_DOWNLOADING: (state, payload) => {
			state.neuralFilmAI.isDownloading = payload;
		},
		SET_NEURAL_FILM_AI_PROCESSING_STEP: (state, payload) => {
			state.neuralFilmAIProcessingStep = payload;
		},
		SET_NEURAL_FILM_AI_PROCESSING_MODAL_TITLE: (state, payload) => {
			state.neuralFilmAIProcessingModalTitle = payload;
		},
		SET_AI_MAGIC_MODE_DOWNLOADING: (state, payload) => {
			state.AIMagicMode.isDownloading = payload;
		},
		SET_AI_EXPOSURE_DOWNLOADING: (state, payload) => {
			state.AIExposure.isDownloading = payload;
		},
		SET_AI_CONTRAST_DOWNLOADING: (state, payload) => {
			state.AIContrast.isDownloading = payload;
		},
		SET_AI_WHITE_BALANCE_DOWNLOADING: (state, payload) => {
			state.AIWhiteBalance.isDownloading = payload;
		},
		SET_AI_MAGIC_MODE_DOWNLOAD_PROGRESS: (state, payload) => {
			state.AIMagicMode.downloadProgress = payload;
		},
		SET_REGENERATE_AI_BASED_PREVIEWS_BUTTON: (state, payload) => {
			state.regenerateAIBasedPreviewsButton = payload;
		},
		SET_ADD_MATCH_TOOLTIP: (state, payload) => {
			state.showAddMatchTooltip = payload;
		},
		SET_SHOW_RAW_DEVELOPMENT: (state, payload) => {
			state.showRawDevelopment = payload;
		},
		UPDATE_CANDIDATE_SEARCH_TERM: (state, payload) => {
			state.candidateSearchTerm = payload;
		},
		UPDATE_MATCHES_SEARCH_TERM: (state, payload) => {
			state.matchSearchTerm = payload;
		},
		SET_BACKGROUND_COLOR: (state, payload) => {
			state.backgroundColor = payload;
		},
		RESET_COMPARE_VIEW: state => {
			state.compareView = []
		},
		ADD_LOADING_ASSET_TO_COMPARE_VIEW: state => {
			state.compareView.push({ loaded: false })
		},
		ADD_ASSET_TO_COMPARE_VIEW: (state, payload) => {
			state.compareView.splice(state.compareView.length - 1, 1, payload);
		},
		UPDATE_COMPARE_VIEW_ITEM: (state, payload) => {
			state.compareView.forEach(item => {
				if (item.id !== payload.assetId) return;

				item[payload.key] = payload.value
			})
		},
		SET_SHOW_LUT_PREVIEWS: (state, payload) => {
			state.showLutPreviews = payload
		},
		SET_SPLIT_VIEW: (state, payload) => {
			state.splitView = payload
		},
		SET_ANIMATION_FOR_ADDING_PRESET: (state, payload) => {
			state.addingPresetAnimation = payload;
		},
		SET_GAMUT_COMPRESSION: (state, payload) => {
			state.gamutCompression = payload;
		},
		TOGGLE_WHATS_NEW_DRAWER: (state, payload) => {
			state.isWhatsNewDrawerOpen = payload;
		},
		SET_WHATS_NEW_BUTTON_ANIMATION: (state, payload) => {
			state.whatsNewButtonAnimation = payload
		},
		SET_RAW_DEVELOPED: (state, payload) => {
			state.rawDeveloped = payload
		},
	},
	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
		setUILoadedStatus: ({ commit }, payload) => {
			commit("SET_UI_LOADED_STATUS", payload);
		},
		setLeftColumn: ({commit}, payload) => {
			commit("SET_LEFT_COLUMN", payload);

			// TODO remove/refactor
			lutify.activeSidebarContainer = payload;

			// if (payload == "project") commit("SET_FILMSTRIP", false);
			// else commit("SET_FILMSTRIP", true);
		},
		setRightColumn: ({commit}, payload) => {
			if (payload == "previews" && !lutify.canUseColorGradingTools()) return;
			if (payload == 'matches' && vm.$store.getters['User/isGuest']) return;

			commit("SET_RIGHT_COLUMN", payload);

			// TODO remove/refactor
			lutify.activePreviewsSidebarContainer = payload;
		},
		setAddBlockList: ({commit}, payload) => {
			commit("SET_ADD_BLOCK_LIST", payload);
		},
		setBlockListSearchTerm: ({commit}, payload) => {
			commit('SET_BLOCK_LIST_SEARCH_TERM', payload);

			const filteredList = [];

			config.blocks.forEach(blockType => {
				const filteredBlockType = {...blockType};
				filteredBlockType.controls = [];

				blockType.controls.forEach(block => {
					if (block?.label.search(new RegExp(`${payload}`, 'i')) !== -1) {
						filteredBlockType.controls.push(block);
					}
				})

				filteredList.push(filteredBlockType);
			})

			commit('SET_FILTERED_BLOCK_LIST', filteredList)
		},
		// setAddBlockMenu: ({commit}, payload) => {
		//     commit("SET_ADD_BLOCK_MENU", payload);
		// },
		setPreviewBasedBlock: ({commit}, payload) => {
			commit("SET_PREVIEW_BASED_BLOCKS", payload);
		},
		setFilmstrip: ({ commit }, payload) => {
			commit("SET_FILMSTRIP", payload);
		},
		setScopes: ({ commit }, payload) => {
			commit("SET_SCOPES", payload);
		},
		setStartTipsStep: ({ commit, rootState }, payload) => {
			if (window.localStorage.getItem("startTipsCompleted")) return;
			if (!payload) {
				if (rootState.User.account.plan_id == rootState.Plans.PLAN_LITE_FREE.id) payload = "free-luts-download";
				else payload = "1";
			}

			window.localStorage.setItem("startTips", payload);
			commit("SET_START_TIPS_STEP", payload);
			if (payload == "completed") window.localStorage.setItem("startTipsCompleted", 1);
		},

		resetVideo: ({ commit }) => {
			commit("RESET_VIDEO");
		},
		setVideoLoaded: ({ commit }, payload) => {
			commit("SET_VIDEO_LOADED", payload);
		},
		setVideoPlaying: ({ commit }) => {
			commit("SET_VIDEO_PLAYING");
		},
		setVideoDuration: ({ commit }, payload) => {
			commit("SET_VIDEO_DURATION", payload);
		},
		setVideoCurrentTime: ({ commit }, payload) => {
			commit("SET_CURRENT_TIME", payload);
		},
		setVideoLoop: ({ commit }) => {
			commit("SET_VIDEO_LOOP");
		},
		setAnimationForAddingMatch: ({commit}) => {
			commit('SET_ANIMATION_FOR_ADDING_MATCH', true);
			setTimeout(() => commit('SET_ANIMATION_FOR_ADDING_MATCH', false), 3000);
		},
		addMatch: ({ commit }, payload) => {
			commit("ADD_MATCH", payload);
		},
		removeMatches: ({ commit }) => {
			commit("REMOVE_MATCHES");
			document.querySelectorAll("#matches .bin-name").forEach(e => e.parentNode.removeChild(e));
		},
		removeMatch: ({ commit }, payload) => {
			commit("REMOVE_MATCH", payload);
		},
		renameMatch: ({ commit }, payload) => {
			commit("RENAME_MATCH", payload);
		},
		setAnimationForAddingCandidate: ({commit}) => {
			commit('SET_ANIMATION_FOR_ADDING_CANDIDATE', true);
			setTimeout(() => commit('SET_ANIMATION_FOR_ADDING_CANDIDATE', false), 3000);
		},
		addCandidate: ({ commit }, payload) => {
			commit("ADD_CANDIDATE", payload);
		},
		updateCandidateThumbnail: ({ commit }, payload) => {
			commit("UPDATE_CANDIDATE_THUMBNAIL", payload);
		},
		removeCandidates: ({ commit }) => {
			commit("REMOVE_CANDIDATES");
		},
		removeCandidate: ({ commit }, payload) => {
			commit("REMOVE_CANDIDATE", payload);
		},
		renameCandidate: ({ commit }, payload) => {
			commit("RENAME_CANDIDATE", payload);
		},
		setAIColourExtractDownloadProgress: ({ commit }, payload) => {
			commit("SET_AI_COLOUR_EXTRACT_DOWNLOAD_PROGRESS", payload);
		},
		setAIColourExtractDownloading: ({commit}, payload) => {
			commit("SET_AI_COLOUR_EXTRACT_DOWNLOADING", payload);
		},
		setAIAutoCorrectDownloadProgress: ({ commit }, payload) => {
			commit("SET_AI_AUTO_CORRECT_DOWNLOAD_PROGRESS", payload);
		},
		setAIAutoCorrectDownloading: ({commit}, payload) => {
			commit("SET_AI_AUTO_CORRECT_DOWNLOADING", payload);
		},
		setNeuralFilmAIDownloadProgress: ({ commit }, payload) => {
			commit("SET_NEURAL_FILM_AI_DOWNLOAD_PROGRESS", payload);
		},
		setNeuralFilmAIDownloading: ({commit}, payload) => {
			commit("SET_NEURAL_FILM_AI_DOWNLOADING", payload);
		},
		setAIMagicModeDownloading: ({commit}, payload) => {
			commit("SET_AI_MAGIC_MODE_DOWNLOADING", payload);
		},
		setAIExposureDownloading: ({commit}, payload) => {
			commit("SET_AI_EXPOSURE_DOWNLOADING", payload);
		},
		setAIContrastDownloading: ({commit}, payload) => {
			commit("SET_AI_CONTRAST_DOWNLOADING", payload);
		},
		setAIWhiteBalanceDownloading: ({commit}, payload) => {
			commit("SET_AI_WHITE_BALANCE_DOWNLOADING", payload);
		},
		setAIMagicModeDownloadProgress: ({ commit }, payload) => {
			commit("SET_AI_MAGIC_MODE_DOWNLOAD_PROGRESS", payload);
		},
		setRegenerateAIBasedPreviewsButton: ({ commit }, payload) => {
			commit("SET_REGENERATE_AI_BASED_PREVIEWS_BUTTON", payload)
		},
		setAddMatchTooltip: ({ commit }, payload) => {
			commit("SET_ADD_MATCH_TOOLTIP", payload);
		},
		setShowRawDevelopment: ({ commit }, payload) => {
			commit("SET_SHOW_RAW_DEVELOPMENT", payload);
		},
		displayFreePlanLimitationMessages: ({ commit, rootState }) => {
			if (rootState.User.account.plan_id == 1) {
				let message = '';

				if (rootState.Projects.projects.length >= 3) {
					message = 'You have used 3 of 3 projects on the free plan. <a href="account/change-plan" style="text-decoration: underline; color: white">Upgrade</a> to unlock unlimited projects.';
				}

				else if (rootState.User.account.number_of_uploaded_images >= 100) {
					message = 'You have used 100 of 100 uploads available on the free plan. <a href="account/change-plan" style="text-decoration: underline; color: white">Upgrade</a> to unlock unlimited uploads.';
				}

				else if (rootState.Organizations.organization.amount_of_uploaded_data >= 1024) {
					message = 'You have used 1GB of storage on the free plan. <a href="account/change-plan" style="text-decoration: underline; color: white">Upgrade</a> to unlock more storage.';
				}

				if (message) {
					vm.$snackbar(message, "error", {
						class: 'free-plan-used',
						timeout: -1,
					});
				}
			}
		},
		setShowLutPreviews: ({commit}, payload) => {
			commit('SET_SHOW_LUT_PREVIEWS', payload)
		},
		setSplitView: ({commit}, payload) => {
			commit('SET_SPLIT_VIEW', payload)
		},
		setAnimationForAddingPreset: ({commit}) => {
			commit('SET_ANIMATION_FOR_ADDING_PRESET', true);
			setTimeout(() => commit('SET_ANIMATION_FOR_ADDING_PRESET', false), 3000);
		},
		setGamutCompression: ({commit}, payload) => {
			commit('SET_GAMUT_COMPRESSION', payload);
		},
		toggleWhatsNewDrawer: ({commit}, payload) => {
			commit('TOGGLE_WHATS_NEW_DRAWER', payload);
		},
		setWhatsNewButtonAnimation: ({commit}) => {
			commit('SET_WHATS_NEW_BUTTON_ANIMATION', true);
			setTimeout(() => commit('SET_WHATS_NEW_BUTTON_ANIMATION', false), 3000);
		},
	},
	getters: {
		filteredCandidates: state => {
			if (!state.candidateSearchTerm) return state.candidates;
			return state.candidates.filter(c => c.nicename.search(new RegExp(`${state.candidateSearchTerm}`, 'i')) !== -1 );
		},
		filteredMatches: state => {
			if (!state.matchSearchTerm) return state.matches;
			return state.matches.filter(m => stripTimestampAndExtension(m.name).search(new RegExp(`${state.matchSearchTerm}`, 'i')) !== -1 );
		},
		candidateById: state => id => {
			return state.candidates.find(candidate => candidate.id == id);
		},
		isRightColumn: state => column => {
			return state.rightColumn == column
		},
		isAddBlockList: state => list => {
			return state.addBlockList == list;
		},
		isLeftColumn: state => column => {
			return state.leftColumn == column
		},
	}
};

export default UI;
